import styled from "styled-components";

export const PersonasReportStyled = styled.div`
  padding: 2rem;

  .report-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem; /* Reduce o ajusta este valor si quieres menos espacio entre elementos */
    margin-bottom: 2rem;
    background-color: #f9f9f9;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
  }

  .report-header h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }

  .report-header .residential-dropdown {
    width: 100%;
    max-width: 400px;
  }

  .report-header .generate-button {
    align-self: flex-start;
    width: auto;
    min-width: 120px;
    margin-top: 0.5rem;
  }

  .table-container {
    width: 100%;
  }

  .loading-message {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: #666;
  }

  @media (min-width: 768px) {
    .report-header {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
    }

    .report-header h2 {
      margin-right: 1rem;
    }

    .report-header .residential-dropdown {
      max-width: 300px;
    }
  }
`;

// ./styled.js

export const PhotoViewerModalStyled = styled.div`
  .modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    min-height: 200px;
    text-align: center;
  }

  .preview-image {
    max-width: 100%;
    max-height: 400px;
    border-radius: 8px;
    object-fit: contain;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;
